/**
 * FsrsPlanGenerator — wraps the existing FSRS engine as a PlanGenerator.
 *
 * One instance per PlanTemplate; registered in PLAN_GENERATORS with id "fsrs-<templateId>".
 */

import type { PlanGenerator, PlanDependencies, SavedPlan } from "./plan-generator.js";
import type { CoachPlan } from "./plan-template.js";
import type { PlanTemplate } from "./plan-template.js";
import { resolveNodes } from "./plan-generator.js";
import { buildCoachPlanInternal } from "./coach-plan.js";

export class FsrsPlanGenerator implements PlanGenerator {
  constructor(readonly template: PlanTemplate) {}

  get id(): string { return `fsrs-${this.template.id}`; }
  get label(): string { return this.template.label; }
  get description(): string { return this.template.description; }

  build(deps: PlanDependencies, plan: SavedPlan, sessionMinutes: number): CoachPlan {
    const effectiveNodes = resolveNodes(this.template.nodes, plan);
    const effectiveConfig = plan.configOverrides
      ? { ...this.template.config, ...plan.configOverrides }
      : this.template.config;

    return buildCoachPlanInternal(
      { ...this.template, nodes: effectiveNodes, config: effectiveConfig },
      {
        items: deps.items,
        cards: deps.cards,
        thresholds: deps.thresholds,
        reviews: deps.reviews,
        sessionTargetMinutes: sessionMinutes,
        sessionMix: plan.sessionMix,
        newSkillNodeId: plan.focusNodeIds?.[0] ?? null,
        nodeExposures: deps.nodeExposures,
        forceAcquired: deps.forceAcquired ?? false,
        now: deps.now,
      },
    );
  }
}
